import(/* webpackMode: "eager" */ "/home/site/wwwroot/src/app/[locale]/(layout)/compare/[...slug]/error.js");
